export const WORKSPACE_PERMISSION = {
    VIEW_WORKSPACE: 'view_workspace',
    EDIT_WORKSPACE: 'edit_workspace',
    DELETE_WORKSPACE: 'delete_workspace',
    ADD_GRAPHS: 'add-graph_workspace',
    VIEW_ALL_GRAPHS: 'view-graphs_workspace',
    EDIT_ALL_GRAPHS: 'edit-graphs_workspace',
    DELETE_ALL_GRAPHS: 'delete-graphs_workspace',
    MANAGE_PERMISSIONS: 'manage-permissions_workspace',
    MANAGE_GRAPHS_PERMISSIONS: 'manage-permissions-graphs_workspace'
}

export const GRAPH_PERMISSION = {
    VIEW_GRAPH: 'view_graph',
    EDIT_GRAPH: 'edit_graph',
    DELETE_GRAPH: 'delete_graph',
    MANAGE_PERMISSIONS: 'manage-permissions_graph'
}

export const GLOBAL_PERMISSION = {
    MANAGE_USERS: 'manage_users',
    MANAGE_SETTINGS: 'manage_settings',
    MANAGE_GRAPHS: 'manage_graphs'
}